import src from "IMAGE";
export default { src, width: 392, height: 60, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AIJs8f+Qd/H/qJDy/6iN8v+Rd/H/hW7x/3hf8P9uXPD/gmQXf7moAn8AAAAASUVORK5CYII="};
